/* import __COLOCATED_TEMPLATE__ from './menu-links.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { toolbarLinkClickAnalytics } from '../utils/analytics';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';
import type AnalyticsService from '@ebiz/ember-aditools-analytics/services/aditools-analytics';

interface MenuLinksArgs {
  activeTab: string;
}

const videoIds = [
  'analog_digital',
  'active_passive',
  'chebyshev_butterworth_bessel',
  'quality_factor',
  'active_filter',
  'sallenkey_feedback',
  'gain_attenuation',
  'opamp_output_impedance',
  'picking_components',
];

export default class MenuLinks extends Component<MenuLinksArgs> {
  @service('aditools-analytics') declare analytics: AnalyticsService;
  @service declare intl: IntlService;
  @tracked videoIds = videoIds;

  @action toolbarMenuClick(menuLink: string): void {
    const tab = this.intl.t('wizard.' + this.args.activeTab, { locale: 'en-us' });
    toolbarLinkClickAnalytics(menuLink, tab, this.analytics);
  }
}
